import React from "react";
import { Card } from "react-bootstrap";
import { FaStar, FaStarAndCrescent, FaStarHalf, FaStarHalfAlt } from "react-icons/fa";
import { Link, useLoaderData } from "react-router-dom";
import "./course.css";
import "./topic.css";

const Topic = (props) => {
  const card = useLoaderData();
  console.log(card);
  const { logo, name, id, price } = props.sub;


  // const handaleDetails = () => {
  //   <Link className="btn-custom" to={`/courses/${id}`}>
  //             Start Quiz
  //           </Link>
  // }


  return (
    <div className="all-sub ms-5 me-3   shadow-lg">
      <Card className="card border-light" >
      {/* <Link className="btn-custom" to={`/courses/${id}`}> */}
        <div className="pt-1">
          <img src={logo} alt="" className="shadow-lg"></img>
          <h5 className="ps-3">{name}</h5>
          <div className="ms-3">
            <FaStar className="text-warning"></FaStar>
            <FaStar className="text-warning"></FaStar>
            <FaStar className="text-warning"></FaStar>
            <FaStar className="text-warning"></FaStar>
            <FaStarHalfAlt className="text-warning"></FaStarHalfAlt>
            <p className="pt-1 fw-semibold">Price : {price}$</p>
          </div>
          <div className="">
            {/* <button className=""> */}
            <Link className="btn-detail text-white pt-2 text-decoration-none" to={`/courses/${id}`}>
              Explore
            </Link>
            {/* </button> */}
          </div>
          
        </div>
      </Card>
      {/* </Link> */}
    </div>
  );
};

export default Topic;
